export default "__VITE_ASSET__BYCl8$Ol__"